export enum PointerShape {
  Circle = 'Circle',
  Square = 'Square',
}
